// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { Observer } from "mobx-vue";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class WarenkorbModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  public created() {
    this.$store.warenkorb.getCurrent();
  }

  public onDelete(event) {
    this.$store.warenkorb.leeren();
  }
}
